"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackValue = exports.imageValueWithObjectFit = exports.imageValue = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const types_1 = require("../files/types");
const translation_1 = require("../translation");
exports.imageValue = {
    source: types_1.FileUsageSource.file,
    id: '',
    accessibility: '',
};
exports.imageValueWithObjectFit = Object.assign(Object.assign({}, exports.imageValue), { objectFit: types_1.ObjectFitEnum.cover });
exports.feedbackValue = {
    info: (0, rich_text_1.textToRtValue)((0, translation_1.t)('elements.testAnswerFeedback.value.info')),
    success: (0, rich_text_1.textToRtValue)((0, translation_1.t)('elements.testAnswerFeedback.value.correct')),
    fail: (0, rich_text_1.textToRtValue)((0, translation_1.t)('elements.testAnswerFeedback.value.incorrect')),
};
